/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Card,
  CardBody,
  Container,
  HStack,
  Heading,
  IconButton,
  ListItem,
  OrderedList,
  Text,
} from '@mybridge/ui';
import React, { useEffect } from 'react';
import Head from 'next/head';
import { useDispatch, useSelector } from 'react-redux';
import { getStaticPageContent } from 'v4/store/actions/global.data.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { BackArrow, BackArrowRTL } from '@mybridge/icons';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { useRouter } from 'next/router';
const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const { pageContetStatic } = useSelector((state) => state.globalData);
  const { t } = useTranslator();
  const direction = useDirection();
  const router = useRouter();
  useEffect(() => {
    dispatch(getStaticPageContent('privacy-policy'));
  }, []);
  return (
    <>
    <Head>
        <title>{t('TnC.privacyPolicy') || "Privacy Policy"} - mybridge</title>
        <meta
          name="description"
          content='myBridge - Our Privacy Policy explains how we collect and use your information while our Terms of Service outlines your responsibilities when using our services.'
        />
        <meta
          name="keywords"
          content="Best websites to find jobs, Social Networking Websites, 
          Online calendar for teams and groups, Free online schedule maker
          , Secure cloud document storage, Free Online Meeting Platform & Solution, No. 1 Spam Free Chat Rooms for online chat, Video chat & Livestream"
        />
      </Head>
      <Container maxW="1366px" className="static-page-container">
        <Card className="static-page-body" boxShadow="none">
          <CardBody>
            <Heading as="h1" fontSize="24px" color="#3D5A80" mb={5}>
              <IconButton size="sm" variant="transparent" onClick={() => router.back()} icon={direction === 'rtl' ? <BackArrowRTL/> : <BackArrow />} />
              {t('TnC.privacyPolicy') || "Privacy Policy"}
            </Heading>

            <Box
            className="static-page-body"
              dangerouslySetInnerHTML={{
                __html: pageContetStatic?.content,
              }}
            ></Box>
            {/* <Heading
              as="h3"
              fontSize="20px"
              fontWeight="400"
              color="#3D5A80"
              mb={5}
            >
              Effective date: 16 March 2023
            </Heading>

            <Heading
              as="h2"
              fontSize="18px"
              fontWeight="600"
              color="#3D5A80"
              mb={3}
            >
              Privacy Statement
            </Heading>
            <Text>
              In this Privacy Statement, we describe how we collect, use, and
              handle your information when you use our websites, software, and
              services ("Services").
            </Text>
            <Text>
              Our Privacy Policy explains how we collect and use your
              information while our Terms of Service outlines your
              responsibilities when using our services. By using our services,
              you are agreeing to be bound by these terms, and to review our
              Privacy Policy and Terms of Service policies. If you are using our
              services for an organization, group or forum, you are agreeing to
              these terms on their behalf.
            </Text>

            <Heading
              as="h5"
              fontSize="18px"
              fontWeight="600"
              color="#3D5A80"
              mb={3}
              mt={5}
            >
              Data we collect and store
            </Heading>
            <Text>
              We collect and use the following information to provide, improve,
              and protect our services:
            </Text>
            <Text>
              <b>Account</b> - We collect information such as your name, email
              address, phone number, payment info, and physical address to
              associate with your account. Some of our services let you access
              your accounts and your information with other service providers.
            </Text>
            <Text>
              <b>Services</b> - When you use our services, we store, process,
              and transmit your files (including information like your photos,
              structured data and emails) and information related to them (for
              example, location tags in photos). If you give us access to your
              contacts, we will store those contacts on our servers for you to
              use. This will make it easy for you to do things like share your
              information, send emails, and invite others to use the services.
            </Text>
            <Text>
              <b>Usage</b> - We collect information from and about the devices
              you use to access the services. This includes things like IP
              addresses, the type of browser and device you use, the web page
              you visited before coming to our sites, and identifiers associated
              with your devices. Your devices (depending on their settings) may
              also transmit location information to the services.
            </Text>
            <Text>
              <b>Cookies and other technologies</b> - We use technologies like
              cookies and pixel tags to provide, improve, protect, and promote
              our services. For example, cookies help us with things like
              remembering your username for your next visit, understanding how
              you are interacting with our services, and improving them based on
              that information. You can set your browser to not accept cookies,
              but this may limit your ability to use the services. If our
              systems receive a DNT:1 signal from your browser, we will respond
              to that signal as outlined here.
            </Text>

            <Heading
              as="h5"
              fontSize="18px"
              fontWeight="600"
              color="#3D5A80"
              mb={3}
              mt={5}
            >
              Circumstances in which we may disclose user data
            </Heading>
            <Text>
              We may share information as discussed below, but we will not sell
              it to advertisers or other third-parties.
            </Text>
            <Text>
              Others working for myBridge use certain trusted third parties to
              help us provide, improve, protect, and promote our services. These
              third parties will access your information only to perform tasks
              on our behalf and in compliance with this Privacy Policy.
            </Text>
            <Text>
              <b>Other users</b> - Our services display information like your
              name and email address to other users in places like your user
              profile and sharing notifications. Certain features let you make
              additional information available to other users.
            </Text>
            <Text>
              <b>Other applications</b> - You can also give third parties access
              to your information and account - for example, via myBridge APIs.
              Just remember that their use of your information will be governed
              by their privacy policies and terms.
            </Text>
            <Text>
              <b>Law and Order</b> - We may disclose your information to third
              parties if we determine that such disclosure is reasonably
              necessary to{' '}
            </Text>
            <ol type="a">
              <li>comply with the law;</li>
              <li>protect any person from death or serious bodily injury;</li>
              <li>prevent fraud or abuse of myBridge or our users; or</li>
              <li>protect myBridge’s property rights.</li>
            </ol>
            <Text>Stewardship of your data is critical to us and a responsibility that we embrace. We believe that our users' data should receive the same legal protections regardless of whether it is stored on our services or on their home computer's hard drive. We will abide by the following Government Request Principles when receiving, scrutinizing, and responding to government requests for our users' data:</Text>
            <ol>
              <li><b>Be transparent,</b></li>
              <li><b>Protect all users,</b></li>
              <li><b>and Provide trusted services</b></li>
            </ol>
            <Heading
              as="h5"
              fontSize="18px"
              fontWeight="600"
              color="#3D5A80"
              mb={3}
              mt={5}
            >
              How
            </Heading>
            <Text><b>Security</b> - We have a team dedicated to keeping your information secure and testing for vulnerabilities. We also continue to work on features to keep your information safe in addition to things like two-factor authentication, encryption of files at rest, and alerts when new devices and apps are linked to your account.</Text>
            <Text><b>Retention</b> – We will retain information you store on our services for as long as we need it to provide you with services. If you delete your account, we will also delete this information. But please note:</Text>
            <ol>
              <li>there might be some latency in deleting this information from our servers and backup storage; and </li>
              <li>we may retain this information if necessary to comply with our legal obligations, resolve disputes, or enforce our agreements.</li>
            </ol>
            <Heading
              as="h5"
              fontSize="18px"
              fontWeight="600"
              color="#3D5A80"
              mb={3}
              mt={5}
            >
              Where
            </Heading>
            <Text><b>Around the world</b> - To provide you with the services, we may store, process, and transmit information in locations around the world - including those outside your country. Information may also be stored locally on the devices you use to access the services.</Text>
            <Text><b>Safe Harbor</b> - myBridge complies with the EU-U.S. and Swiss-U.S. Safe Harbor ("Safe Harbor") frameworks and principles. We have certified our compliance, and you can view our certifications here. You can learn more about Safe Harbor by visiting export.gov . JAMS is the independent organization responsible for reviewing and resolving complaints about our Safe Harbor compliance. We ask that you first submit any such complaints directly to us via privacy@myBridge.me</Text>
            <Heading
              as="h5"
              fontSize="18px"
              fontWeight="600"
              color="#3D5A80"
              mb={3}
              mt={5}
            >
              Changes
            </Heading>
            <Text>If we are involved in a reorganization, merger, acquisition, or sale of our assets, your information may be transferred as part of that deal. We will notify you (for example, via a message to the email address associated with your account) of any such deal and outline your choices in that event.</Text>
            <Text>We may revise this Privacy Policy from time to time and will post the most current version on our website. If a revision meaningfully reduces your rights, we will notify you.</Text>
            <Heading
              as="h5"
              fontSize="18px"
              fontWeight="600"
              color="#3D5A80"
              mb={3}
              mt={5}
            >
              Contact
            </Heading>
            <Text>Have questions or concerns about myBridge, our services and privacy? Contact us at terms@myBridge.me</Text> */}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
